import { dispatchPageView } from './page-view-event.js';

// Loaded once per full page load via layout/theme.liquid. Module side effects only —
// see page-view-event.js for the pure helper imported by tests. Fires on
// DOMContentLoaded so listeners mounted later in the document are ready.
if (document.readyState === 'complete') {
  dispatchPageView();
} else {
  document.addEventListener('DOMContentLoaded', () => dispatchPageView(), { once: true }); // spec-audit-disable-line no-domcontentloaded
}
